import React from "react";

interface IconProps {
  style?: React.CSSProperties;
}

const LeftArrowIcon: React.FC<IconProps> = ({ style }) => (
  <svg
    width='25'
    height='44'
    viewBox='0 0 25 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
  >
    <path
      d='M21.778 3.33326L3.11132 21.9999L21.778 40.6666'
      stroke='#003C73'
      strokeWidth='7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default LeftArrowIcon;
